
'use strict';
const angular = require('angular');
import { extendedCRUDMethods } from "./extendedCRUDMethods";

export default function AssistantResource($resource) {
    'ngInject';
    return $resource('/api/assistants/:id', { id: '@id' }, extendedCRUDMethods);
}



// WEBPACK FOOTER //
// ./client/components/resources/assistant.resource.ts